/* eslint-disable no-console */
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { KeycloakProvider } from "@react-keycloak/web";
import { Loader } from "@googlemaps/js-api-loader";
import { RouteProps } from "react-router-dom";
import Header from "components/layout/Header";
import VerticalNavigation from "components/layout/VerticalNavigation";
import AuthRoute from "lib/routes/AuthRoute";
import keycloak from "lib/keycloak";

interface StandaloneContextValue {
  authRoute: React.FC<RouteProps> | null;
}

export const StandaloneContext = React.createContext<StandaloneContextValue>({
  authRoute: null,
});

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 44,
    width: "100%",
    overflowY: "auto",
  },
}));

export const StandaloneProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  window.KEYCLOAK = keycloak;

  const classes = useStyles();
  const eventLogger = (event: unknown, error: unknown) => {
    // eslint-disable-next-line no-console
    console.log("onKeycloakEvent", event, error);
  };

  const tokenLogger = (tokens: unknown) => {
    // eslint-disable-next-line no-console
    console.log("onKeycloakTokens", tokens);
  };

  useEffect(() => {
    localStorage.setItem(
      "WIS_URL",
      `//${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}` || ""
    );
    localStorage.setItem(
      "WIS_API_URL",
      process.env.REACT_APP_WIS_API_URL || ""
    );
    localStorage.setItem(
      "HVS_API_URL",
      process.env.REACT_APP_HVS_API_URL || ""
    );
  }, []);

  // in embedded mode we can leverage HVS already loaded
  // leaflet CSS and google maps API

  // eslint-disable-next-line global-require
  require("leaflet/dist/leaflet.css");

  // eslint-disable-next-line global-require
  require("font-awesome/css/font-awesome.css");

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API || "",
      version: "weekly",
    });

    loader.load();
  }, []);

  return (
    <StandaloneContext.Provider value={{ authRoute: AuthRoute }}>
      <KeycloakProvider
        keycloak={keycloak}
        initConfig={{
          onLoad: "login-required",
        }}
        onEvent={eventLogger}
        onTokens={tokenLogger}
      >
        <>
          <Header />
          <VerticalNavigation />
          <div id="wis-container" className={classes.container}>
            {children}
          </div>
        </>
      </KeycloakProvider>
    </StandaloneContext.Provider>
  );
};
